/* eslint-disable @typescript-eslint/no-explicit-any */
import IconArrow from '@assets/icons/big arrow right.svg?react';
import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';

import customColors from '../../../utils/customColors';
import { isJson } from '../../../utils/dataTypes';
import { usePage } from '../../../contexts/usePageContext';

const badgeStyles = {
 display: 'inline-flex',
 alignItems: 'center',
 justifyContent: 'center',
 borderRadius: '15px',
 px: 1,
 py: '4px',
 fontWeight: 500,
};

const limitColorMap = {
 red: customColors.lightRed,
 green: customColors.lightGreen,
 orange: customColors.lightOrange,
 yellow: customColors.lightYellow,
 blue: customColors.lightBlue,
};

const statusMap = {
 0: customColors.lightGreen,
 1: customColors.lightYellow,
 2: customColors.lightYellow,
 3: customColors.lightRed,
 4: customColors.lightBlue,
};

const xRenderCell = (
 params: GridRenderCellParams,
 name: string,
 type: string,
 customValue: string = '',
) => {
 const value =
  customValue && customValue !== 'undefined' ? customValue : params.value;

 if ((!value && value !== 0) || value === 'null') return '';

 if (params?.rowNode?.type === 'group') {
  return params?.formattedValue ? params.rowNode.groupingKey : value;
 }

 if (params.field === 'State') {
  return (
   <Typography
    className="limit-span"
    sx={{
     ...badgeStyles,
     color: (theme) =>
      theme.palette.mode === 'dark'
       ? theme.palette.kemek.white // not actually white
       : theme.palette.kemek.darkestGray,
     backgroundColor: (statusMap as any)?.[params.value],
    }}
   >
    {value}
   </Typography>
  );
 }
 if (params.field === 'Cargo') {
  return (
   <Box
    sx={{
     display: 'inline-flex',
     alignItems: 'center',
     justifyContent: 'center',
     borderRadius: '50%',
     background: (theme) => theme.palette.kemek.lightBlue,
     width: '24px',
     height: '24px',
    }}
   >
    <IconArrow
     title={value}
     style={{
      transform: value === 'In' ? 'rotate(180deg)' : '',
     }}
    />
   </Box>
  );
 }
 if (type === 'boolean') {
  return value ? '+' : '-';
 }
 if (['int32', 'int16', 'double', 'decimal'].includes(type)) {
  // LIMITS
  const { pageName } = usePage();

  const lsValue = localStorage.getItem(
   `${import.meta.env.VITE_APP_NAME}_${pageName}`,
  );

  const tempState = isJson(lsValue || '')
   ? JSON.parse(lsValue || '{}').columns
   : [];
  const thisLimits = tempState?.limit?.[params.field] || [];
  let lastLimitIndex = -1;
  if (thisLimits.length) {
   thisLimits.forEach((item: any) => {
    if (item.limit === '<') {
     if (value < item.value) {
      lastLimitIndex = thisLimits.indexOf(item);
     }
    } else if (item.limit === '>') {
     if (value > item.value) {
      lastLimitIndex = thisLimits.indexOf(item);
     }
    }
   });
  }

  const selectedValue = value || params.value;
  const parts = selectedValue.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const formattedValue = parts.join('.');

  const hasLimit = lastLimitIndex !== -1;

  // && name !== 'Neto'  ???
  return !hasLimit ? (
   formattedValue
  ) : (
   <Typography
    className="limit-span"
    sx={{
     ...badgeStyles,
     color: (theme) =>
      theme.palette.mode === 'dark'
       ? theme.palette.kemek.white // not actually white
       : theme.palette.kemek.darkestGray,
     backgroundColor: (limitColorMap as any)?.[
      hasLimit ? thisLimits[lastLimitIndex].color : 'blue'
     ],
    }}
   >
    {formattedValue}
   </Typography>
  );
 }
 if (type === 'datetime') {
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
 }

 if (type === 'array' || typeof value === 'object') {
  let arrayReturn = '';
  if (['ResultProducts', 'CardProducts'].includes(params.field)) {
   arrayReturn = value
    .map((item: any) => `${item.Product.Name} (${item.Percentage}%)`)
    .join(', ');
  } else {
   arrayReturn = Object.keys(value).length ? JSON.stringify(value) : '';
  }
  return <Typography sx={{ fontSize: 9 }}>{arrayReturn}</Typography>;
 }
 return value;
};

export default xRenderCell;
